import CustomInput from "../CustomInput/CustomInput.vue";
export default {
    name: 'CustomLink',
    components: {
        CustomInput
    },
    data() {
        return {
            tag_1: '',
            tag_2: '',
            tagsChanged: {
                '1': false,
                '2': false
            },
            showErrorMessage: false,
        }
    },
    props: {
        tag1_prop: {
            type: String
        },
        tag2_prop: {
            type: String
        },
        errors: {
            default: null
        }
    },
    watch: {
        tag_1 (v) {
            this.$emit('changeTag1', {
                value: v
            })
        },
        tag_2 (v) {
            this.$emit('changeTag2', {
                value: v
            })
        }
    },
    computed: {
        domain () {
          return process.env.VUE_APP_URL
        },
        tag1Error () {
          return this.tag_1.length < 5 ? "The tags must be 5-50 characters long" : ""
        },
        tag2Error () {
          return this.tag_2.length < 5 ? "The tags must be 5-50 characters long" : ""
        },
        url () {
          return this.domain +
          (this.tag_1.length ? '/' : '') + this.tag_1 +
          (this.tag_2.length ? '/' : '') + this.tag_2
      }
    },
    methods: {
        changeTag1 (data) {
            if (!this.tagsChanged["1"]) this.tagsChanged["1"] = true
            /*if (this.tag_1 && (data.inp.length < this.tag_1.length) && data.inp < 1 ) {
                this.showErrorMessage = true
            }*/
            this.tag_1 = data.inp
        },
        changeTag2 (data) {
            if (!this.tagsChanged["2"]) this.tagsChanged["2"] = true
            /*if (this.tag_2 && (data.inp.length < this.tag_2.length) && data.inp < 1 ) {
                this.showErrorMessage = true
            }*/
            this.tag_2 = data.inp
        }
    },
    mounted () {
        this.showErrorMessage = false
        this.tag_1 = this.tag1_prop
        this.tag_2 = this.tag2_prop
    },
    created() {}
}
